export default __webpack_public_path__ + "static/media/ClothingAccessories.4b5d958f.svg";